import { getBottomComponentHtml } from '../../../src/facts/table-view';

require('./incidents-modal.component.scss');
const incidentsUrl = '/incident/api/incidents_full/';

export const IncidentsModalController = function(
  $scope,
  PermissionService,
  $modalInstance,
  $timeout,
  $http
) {
  $scope.incidents = [];
  $scope.selections = {};
  $scope.sort = {
    field: '',
    dir: ''
  };
  $scope.isLoading = true;
  let cols = [];

  $modalInstance.opened.then((res, res2) => {
    $timeout(() => {
      const wMax = 1000;
      const w = document.body.clientWidth;
      if (w > wMax) {
        const el = document.querySelector('.add-to-incidents');
        el.style.left = `calc(50% - ${wMax / 2}px)`;
      }
    }, 100);
  });

  const token = (() => {
    const tokenCookie = document.cookie
      .split('; ')
      .find(c => c.startsWith('csrftoken='));
    return tokenCookie && tokenCookie.split('=')[1];
  })();
  const cteatorId = PermissionService.userId;
  const postData = (url, data) => {
    return $http.post(url, data, {
      headers: (token && {
        'X-CSRFToken': token,
        'Content-Type': 'application/json'
      }) || {
        'Content-Type': 'application/json'
      }
    });
  };

  const addComment = (text, incidentId) => {
    $scope.isLoading = true;
    $timeout(() => {
      $scope.$digest();
    }, 10);
    return postData('/incident/api/comment/', {
      date: new Date().toJSON(),
      text: text,
      creator: cteatorId,
      incident: incidentId
    });
  };
  const rebuild = html => {
    return html.replace('ng-src', 'src');
  };

  const incidentsPromice = () => {
    let url = incidentsUrl;
    if ($scope.sort.field)
      url = `${url}?ordering=${$scope.sort.dir}${$scope.sort.field}`;
    return $http.get(url);
  };

  const responsePatternsPromice = () => {
    return $http.get('/incident/api/response_pattern/');
  };

  const incidentGroupsPromice = () => {
    return $http.get('/incident/api/incident_group/');
  };

  const getIncidents = () => {
    incidentsPromice().then(
      res => {
        $scope.incidents = res.data;
        $scope.isLoading = false;
        if (!$scope.$root.$$phase) $scope.$digest();
      },
      () => {
        $scope.isLoading = false;
        $modalInstance.dismiss(gettext('Ошибка  загрузки'));
      }
    );
  };

  const incidentColsPromice = () => {
    const url = '/incident/api/incidents/';
    return $http({
      method: 'OPTIONS',
      url: url
    });
  };

  const incidentStatusesPromice = () => {
    return $http.get('/incident/api/status/');
  };

  Promise.all([
    incidentsPromice(),
    incidentColsPromice(),
    incidentStatusesPromice(),
    responsePatternsPromice(),
    incidentGroupsPromice()
  ]).then(
    ([
      incidents,
      incidentCols,
      incidentStatuses,
      responsePatterns,
      incidentGroups
    ]) => {
      if (incidents && incidents.data) $scope.incidents = incidents.data;
      if (
        incidentCols &&
        incidentCols.data &&
        incidentCols.data.actions &&
        incidentCols.data.actions.POST
      ) {
        const colsObj = incidentCols.data.actions.POST;
        cols = Object.keys(colsObj).map(k => {
          const col = {
            name: k,
            label: colsObj[k].label,
            type: colsObj[k].type
          };
          if (colsObj[k].choices) col.choices = colsObj[k].choices;
          return col;
        });

        if (incidentStatuses && incidentStatuses.data) {
          $scope.incidentStatus = incidentStatuses.data.find(
            s => s.name.toLowerCase() === 'new'
          );
          if (!$scope.incidentStatus)
            $scope.incidentStatus = incidentStatuses.data[0];
        }

        if (responsePatterns && responsePatterns.data) {
          $scope.responsePatterns = responsePatterns.data;
          if ($scope.responsePatterns[0])
            $scope.selections.responsePattern = $scope.responsePatterns[0];
        }
        if (incidentGroups && incidentGroups.data) {
          $scope.incidentGroups = incidentGroups.data;
          if ($scope.incidentGroups[0])
            $scope.selections.incidentGroup = $scope.incidentGroups[0];
        }
      }
      $scope.isLoading = false;
      if (!$scope.$root.$$phase) $scope.$digest();
    }
  );

  $scope.shownColls = () => cols.filter(c => c.name !== 'description');

  $scope.addNew = () => {
    $scope.isLoading = true;
    const incident = {
      date: new Date().toJSON(),
      subject: gettext('На основании события') + `: ${$scope.fact.id}`,
      description:
        gettext('Данный инцидент создан на основании события') +
        `: ${$scope.fact.id}`,
      status: $scope.incidentStatus.id,
      creator: cteatorId,
      assignee: cteatorId,
      priority: 'minor',
      pattern: $scope.selections.responsePattern.id,
      group: $scope.selections.incidentGroup.id
    };
    postData('/incident/api/incidents/', incident).then(
      res => {
        if (res.data && res.data.id) {
          $scope.selectIncident(res.data.id, true);
        } else {
          console.error('incident is not created');
        }
      },
      err => {
        $scope.isLoading = false;
        $modalInstance.dismiss(err);
      }
    );
  };

  $scope.selectIncident = (incidentId, isNew) => {
    let factHtml = '';
    const bottomEl = document.getElementById(`id_bottom_${$scope.fact.id}`);
    if (bottomEl) factHtml = rebuild(bottomEl.outerHTML);
    else factHtml = rebuild(getBottomComponentHtml($scope.fact));

    addComment(factHtml, incidentId).then(
      res => {
        window.open(
          `/incident/#incident/?id=${incidentId}${isNew ? '&isEdit=true' : ''}`
        );
        $scope.isLoading = false;
        $scope.cancel();
      },
      err => {
        $scope.isLoading = false;
        $modalInstance.dismiss(err);
      }
    );
  };

  const dateFilter = d =>
    d
      .toString()
      .replace('T', ' ')
      .substring(0, 19);

  $scope.sort = field => {
    $scope.isLoading = true;

    if ($scope.sort.field === field) {
      $scope.sort.dir = $scope.sort.dir ? '' : '-';
    } else {
      $scope.sort.field = field;
      $scope.sort.dir = '';
    }
    getIncidents();
  };

  $scope.colValue = (col, incident) => {
    if (col.type === 'datetime') return dateFilter(incident[col.name]);
    if (col.type === 'field' && incident[col.name].username)
      return getUserName(incident[col.name]);
    if (col.type === 'field') return incident[col.name].name;
    if (col.type === 'choice' && col.choices) {
      const val = col.choices.find(ch => ch.value === incident[col.name])
        .display_name;
      return val ? val : incident[col.name];
    }
    return incident[col.name];
  };

  const getUserName = user =>
    user.first_name || user.last_name
      ? `${user.first_name} ${user.last_name}`
      : user.username;

  $scope.cancel = () => $modalInstance.close('cancel');
};



// WEBPACK FOOTER //
// ./src/facts/add-to-incidents/incidents-modal.component.js